import React from "react";
import { Pagination } from "semantic-ui-react";

const ItemTotal = ({ total }) =>
  total ? <div className="p-total">{total} items</div> : null;

const ObjectPagination = ({ objects, onPageChange }) => (
  <div className="o-pagination">
    <ItemTotal total={objects.length} />
    {objects.length > 50 ? (
      <Pagination
        style={{ marginBottom: "1em" }}
        defaultActivePage={1}
        totalPages={Math.ceil(objects.length / 50)}
        size="mini"
        onPageChange={(event, data) => onPageChange(event, data)}
      />
    ) : null}
  </div>
);

export default ObjectPagination;
